import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {NotificationService} from "~/app/core/notification.service";
import {UserProfileService} from "~/app/core/user-profile-service/user-profile.service";
import {ApiService} from "~/app/core/api.service";
import {Settings} from "~/app/core/model/settings";
import * as Log from "~/app/core/log";
import {CoreService} from "~/app/core/core.service";
import {UserInfo} from "~/app/core/model/user-info";

@Component({
    selector: "accountNotification",
    templateUrl: "./accountNotification.component.html",
    styleUrls: ["./accountNotification.component.scss"]
})
export class AccountNotificationComponent implements OnInit {
  settings: Settings;
  newOfferPushNotifications: boolean;
  bouncebackOfferPushNotifications: boolean;
  contestAndPromotionTextNotifications: boolean;
  newOfferTextNotifications: boolean;
  gamingMilestoneNotifications: boolean;
  gamingAdvancementNotifications: boolean;
  userInfo: UserInfo;
  constructor(
    private readonly api: ApiService,
    private readonly cd: ChangeDetectorRef,
    private readonly userProfileService: UserProfileService,
    private readonly core: CoreService) {
  }

  ngOnInit(): void {
    this.settings = this.api.device_loadSettings();
    this.newOfferPushNotifications = this.settings.useNewOfferNotifications;
    this.bouncebackOfferPushNotifications = this.settings.useBouncebackNotifications;
    this.newOfferTextNotifications = false;
    this.contestAndPromotionTextNotifications = false;
    this.gamingMilestoneNotifications = false;
    this.gamingAdvancementNotifications = false;
    this.userInfo = this.userProfileService.userInfo;
  }

  saveSettings() {
    this.core.api.device_saveSettings(this.settings);
  }

  onNewOfferPushNotifications() {
    this.settings.useNewOfferNotifications = this.newOfferPushNotifications;
    this.saveSettings();
  }

  onBouncebackOfferPushNotifications() {
    this.settings.useBouncebackNotifications = this.bouncebackOfferPushNotifications;
    this.saveSettings();
  }

  onContestAndPromotionTextNotifications() {
    // TODO we need to add this setting to the back-end/database
    this.saveSettings();
  }

  onNewOfferTextNotifications() {
    // TODO we need to add this setting to the back-end/database
    this.saveSettings();
  }

  onGamingMilestoneNotificactions() {
    // TODO we need to add this setting to the back-end/database
    this.saveSettings();
  }

  onGamingAdvancementNotifications() {
    // TODO we need to add this setting to the back-end/database
    this.saveSettings();
  }

//   this.core.notify.isAllowNotification().then((allow) => {
//   this.readStatus();
//   this.allowNotifications = allow;
//   const useBouncebackNotifications = allow && this.localSettings.useBouncebackNotifications;
//   if (useBouncebackNotifications !== this.localSettings.useBouncebackNotifications) {
//   this.localSettings.useBouncebackNotifications = useBouncebackNotifications;
//   this.core.api.device_saveSettings(this.localSettings);
// }
// const useReminderNotifications = allow && this.localSettings.useReminderNotifications;
// if (useReminderNotifications !== this.localSettings.useReminderNotifications) {
//   this.localSettings.useReminderNotifications = useReminderNotifications;
//   this.core.api.device_saveSettings(this.localSettings);
// }
// const useNewOfferNotifications = allow && this.localSettings.useNewOfferNotifications;
// if (useNewOfferNotifications !== this.localSettings.useNewOfferNotifications) {
//   this.localSettings.useNewOfferNotifications = useNewOfferNotifications;
//   this.core.api.device_saveSettings(this.localSettings);
// }
// this.cd.detectChanges();
}
